import { render, staticRenderFns } from "./videoAdd.vue?vue&type=template&id=833156d0&scoped=true&"
import script from "./videoAdd.vue?vue&type=script&lang=js&"
export * from "./videoAdd.vue?vue&type=script&lang=js&"
import style0 from "./videoAdd.vue?vue&type=style&index=0&id=833156d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833156d0",
  null
  
)

export default component.exports